<div class="bg-cool-gray-100 header" #headerContainer>
  <!-- Header left -->
  <div class="left" #leftContainer>
    <div class="breadcrumb">
      <span data-cy="deal-title-label" class="path">
        <a [routerLink]="['/properties']">Properties</a>
        <span class="separator">/</span>
        <span data-cy="project-title"
          ><a [routerLink]="['/properties/' + property.id]">{{ property.name }}</a></span
        >
      </span>
    </div>
  </div>

  <!-- Tabs pagination options -->
  <div class="menu" #menuContainer>
    <a
      [appAuthorize]="hasPermission(Permission.PROPERTY_DETAILS_TAB)"
      [routerLink]="[propertiesRoute + '/details']"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ subset: true }"
      >Details
    </a>
    @if (FeatureFlag.ASSET_MANAGEMENT | hasFeature) {
      <a
        [appAuthorize]="hasPermission(Permission.PROPERTY_DETAILS_TAB)"
        [routerLink]="[propertiesRoute + '/asset-management/general-ledger']"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ subset: true }"
        >Financials
      </a>
    }
    <a
      [appAuthorize]="hasPermission(Permission.PROPERTY_FILES_TAB)"
      data-cy="properties-files"
      [routerLink]="[propertiesRoute + '/folders']"
      [routerLinkActive]="['active']"
    >
      Files
      <span class="badge" *ngIf="property?.num_documents">{{ property.num_documents }}</span>
    </a>
    <!-- <a
      [appAuthorize]="canShowTaskTab()"
      [routerLink]="[propertiesRoute + '/tasks']"
      [routerLinkActive]="['active']"
      data-cy="properties-tasks-tab"
    >
      Tasks
      <span class="badge" *ngIf="property?.num_open_tasks">
        {{ property.num_open_tasks }}
      </span>
    </a> -->
    <a
      [appAuthorize]="canShowTaskTab()"
      [routerLink]="[propertiesRoute + '/new-tasks', 'Property', property.id]"
      [routerLinkActive]="['active']"
      data-cy="properties-tasks-tab"
    >
      Tasks
      <span class="badge" *ngIf="property?.num_open_tasks">
        {{ property.num_open_tasks }}
      </span>
    </a>
    <a
      [appAuthorize]="canAccessNotes()"
      [routerLink]="[propertiesRoute + '/notes']"
      [routerLinkActive]="['active']"
      data-cy="properties-notes-tab"
    >
      Notes
      <span class="badge" *ngIf="property?.num_notes">
        {{ property.num_notes }}
      </span>
    </a>
    @if (FeatureFlag.NEW_LEASES_TAB | hasFeature) {
      <a
        [appAuthorize]="canAccessLeases()"
        [routerLink]="[propertiesRoute + '/leases']"
        [routerLinkActive]="['active']"
        data-cy="properties-leases-tab"
        >Leases</a
      >
    } @else {
      <a
        [appAuthorize]="canAccessLeases()"
        [routerLink]="[propertiesRoute + '/units']"
        [routerLinkActive]="['active']"
        data-cy="properties-leases-tab"
        >Units</a
      >
    }

    <a
      [appAuthorize]="canAccessDeals()"
      [routerLink]="[propertiesRoute + '/deals']"
      [routerLinkActive]="['active']"
      data-cy="properties-deals-tab"
      >Deals</a
    >
    <a
      [appAuthorize]="hasPermission(Permission.PROPERTY_NEARBY_TAB)"
      [routerLink]="[propertiesRoute + '/nearby']"
      [routerLinkActive]="['active']"
      data-cy="properties-nearby-tab"
      >Nearby</a
    >

    <!-- VISIBLE CUSTOM OBJECTS TABS -->
    <ng-container *ngIf="hasCustomObjectPermission()">
      <ng-container *ngIf="hasCustomObjectsEnabled$ | async">
        <a
          *ngFor="let customObjectTab of visibleCustomObjectsTabs"
          [routerLink]="[propertiesRoute + '/custom_object', customObjectTab.id]"
          [queryParams]="{ related_to_type: relatedToTypeProperty, related_to_id: property.id }"
          [routerLinkActive]="['active']"
        >
          {{ customObjectTab.label_plural || customObjectTab.label }}
        </a>

        <!-- HIDDEN CUSTOM OBJECTS TABS -->
        <ng-container *ngIf="hasDropDown && customObjectsTabs?.length">
          <a
            [routerLink]="[propertiesRoute + '/custom_object', selectedCustomObjectTab.id]"
            [queryParams]="{ related_to_type: relatedToTypeProperty, related_to_id: property.id }"
            [routerLinkActive]="['active']"
          >
            {{ selectedCustomObjectTab?.label_plural || selectedCustomObjectTab?.label }}
          </a>
          <button class="menuHiddenCO" mat-icon-button [matMenuTriggerFor]="menuHiddenCO">
            <mat-icon [svgIcon]="'expand_more'"></mat-icon>
          </button>
          <mat-menu #menuHiddenCO="matMenu">
            <button
              mat-menu-item
              *ngFor="let customObjectTab of hiddenCustomObjectsTabs"
              (click)="selectCustomObjectTab(customObjectTab, true)"
            >
              {{ customObjectTab.label_plural || customObjectTab.label }}
            </button>
          </mat-menu>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <!-- Header right -->
  <div class="right" #rightContainer>
    <button
      class="w-7 previous-button"
      (click)="goToPrevious()"
      mat-icon-button
      [matTooltip]="'Previous Property'"
      [disabled]="!(currentPropertyIndex > 0)"
    >
      <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
    </button>
    <button
      class="w-6 next-button"
      (click)="goToNext()"
      mat-icon-button
      [matTooltip]="'Next Property'"
      [disabled]="!(propertyList?.length > 0 && propertyList?.length !== currentPropertyIndex + 1)"
    >
      <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
    </button>
    <ng-container>
      <button
        data-cy="properties-more-button"
        mat-icon-button
        class="more-menu"
        [matMenuTriggerFor]="moreMenu"
        [appAuthorize]="canShowThreeDotMenu(property)"
        denyAction="disable"
      >
        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu">
        <button
          [appAuthorize]="NewPermission.PROPERTIES_SHARING_RECORDS"
          denyAction="hide"
          mat-menu-item
          (click)="openGenerateModal()"
        >
          <mat-icon [svgIcon]="'description'"></mat-icon>
          Generate Merge Document
        </button>
        <button
          mat-menu-item
          (click)="changePropertyTemplate()"
          [appAuthorize]="Permission.PROPERTY_DASHBOARD_EDIT_LAYOUT"
        >
          <mat-icon [svgIcon]="'sync_alt'"></mat-icon>
          Change Layout
        </button>
        <button
          [appAuthorize]="getDeletePropertyPermission()"
          data-cy="properties-delete-button"
          mat-menu-item
          (click)="deleteProperty()"
        >
          <mat-icon [svgIcon]="'delete'"></mat-icon>
          <span>Delete Property</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</div>
